import React from "react";
import Explainer from "../ExplainerModal";

const TrackingAndAssessmentExplainer = () => {
  return (
    <Explainer
      title="📊 Tracking & Assessment Explainer"
      content={
        <>
          <p>
            The <strong>Tracking & Assessment</strong> section enables the management of milestones for <strong>E-Tracker</strong> and <strong>Benchmarking</strong>, as well as focal areas for <strong>Landscaping</strong>.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔒 Locked vs. Unlocked Milestones/Focal Areas
          </h3>
          <ul>
            <li>
              A <strong>locked</strong> milestone or focal area is indicated by a <strong>lock icon 🔒</strong> under the <em>Actions</em> column.
            </li>
            <li>
              When <strong>unlocked</strong>, you will see the <strong>✏️ edit</strong> and <strong>🗑️ delete</strong> icons under the <em>Actions</em> column.
            </li>
            <li>
              For a <strong>locked</strong> milestone or focal area, only the <strong>Owner</strong> and <strong>Supervisor</strong> can be edited by clicking on the <strong>✏️ edit</strong> icon beside the owner's and supervisor's names, while its contents remain uneditable.
            </li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            ➕ Creating Custom Milestones & Focal Areas
          </h3>
          <p>
            The platform allows users to create additional <strong>E-Tracking</strong> and <strong>Benchmarking milestones</strong>, as well as <strong>Landscaping focal areas</strong>, tailored to specific countries, by clicking on the <strong>Create New</strong> button.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📌 Where Milestones & Focal Areas Appear
          </h3>
          <p>
            Once created, a milestone or focal area will be available under the <strong>Benchmarking</strong>, <strong>Policy Landscaping</strong>, and <strong>E-Tracker milestones</strong> pages for <strong>owners</strong> and <strong>supervisors</strong> to take action.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            👤 Roles & Permissions
          </h3>
          <ul>
            <li>🛠️ <strong>Owners</strong> can be either a <strong>user</strong> or an <strong>administrator</strong>.</li>
            <li>🔧 <strong>Supervisors</strong> can only be <strong>administrators</strong>.</li>
          </ul>
        </>
      }
    />
  );
};

export default TrackingAndAssessmentExplainer;
